const GUEST_COUNT_PATTERN = /^\d+$/

/** Reads a whole guest count of 1 or more; anything else is null. */
export function parseGuestCount(raw: unknown): number | null {
  const count = typeof raw === 'string' && GUEST_COUNT_PATTERN.test(raw.trim()) ? Number(raw) : raw
  return typeof count === 'number' && Number.isSafeInteger(count) && count >= 1 ? count : null
}
